import { Modal } from '@magnetic/modal'
import { Flex } from '@magnetic/flex'
import { Heading } from '@magnetic/heading'
import { Notification } from '@magnetic/notification'
import { Text } from '@magnetic/text'
import { Button } from '@magnetic/button'
import { Spinner } from '@magnetic/spinner'
import { Trash } from '@/lib/icons'

interface ForceDeleteModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  applicationName: string
  isPending: boolean
}

export function ForceDeleteModal({
  isOpen,
  onClose,
  onConfirm,
  applicationName,
  isPending,
}: ForceDeleteModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
    >
      <Modal.Content>
        <Flex direction="vertical" gap="md" style={{ padding: 24 }}>
          <Heading size="section">Force Delete Application</Heading>
          <Notification status="negative" title="Dangerous Operation">
            <Text size="p4">
              Force delete bypasses ArgoCD finalizers and immediately removes the application record.
            </Text>
          </Notification>

          <Text size="p3">
            Only use force delete if:
          </Text>
          <Flex direction="vertical" gap="xs">
            <Text size="p4">- Normal deletion has been stuck for more than 5 minutes</Text>
            <Text size="p4">- ArgoCD finalizers are blocking deletion</Text>
            <Text size="p4">- The application CRD is corrupted or missing</Text>
          </Flex>

          <Text size="p4" weight="semi-bold">
            This will immediately remove <strong>{applicationName}</strong> from the database,
            but Kubernetes resources may remain in the cluster.
          </Text>

          <Flex gap="sm" justify="flex-end">
            <Button
              kind="secondary"
              onClick={onClose}
              disabled={isPending}
            >
              Cancel
            </Button>
            <Button
              destructive
              onClick={onConfirm}
              disabled={isPending}
              icon={isPending ? <Spinner size="sm" aria-label="Force deleting" /> : <Trash size={16} />}
            >
              {isPending ? 'Force Deleting...' : 'Force Delete Now'}
            </Button>
          </Flex>
        </Flex>
      </Modal.Content>
    </Modal>
  )
}
